import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ItemModal from './ItemModal';
import ReactDOM from 'react-dom';
import './ItemList.css';

export default function ItemList({ items, post, setItemGives, onGive, setChangeItemIconColor, socket, onItemClick, setseenGifts }) {
    // if(!items){
    //     return (
    //         <div className="no-items">
    //             <p>
    //             Sorry no items were found
    //             </p>
    //         </div>
    //     )
    // }

    const [selectedItem, setSelectedItem] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const uniqueItems = [];
    const itemIds = new Set();
    console.log("items: ", items);
    items.forEach((item) => {
        if (!itemIds.has(item.itemId)) {
            uniqueItems.push(item);
            itemIds.add(item.itemId);
        }
    });

    // useEffect(() => {
    //     console.log("setting isLoading to false");
    //     setIsLoading(false);
    // },[items])

    console.log("uniqueItems:", uniqueItems);
    
    const clickItem = (item) => {
        let shippingPrice;
        const itemPrice = parseFloat(item.price.value);
        if (item.shippingOptions[0].shippingCostType === "CALCULATED"){
            shippingPrice = "Calculated";
        } else {
            shippingPrice = parseFloat(item.shippingOptions[0].shippingCost.value);
        }

        let allItemImages = [];
        let additionalImages = item.additionalImages;
        if(additionalImages){
            // put all images (main and additional) into one array
            allItemImages.push({imageUrl: item.image.imageUrl});
    
            for(let i = 0; i < additionalImages.length; i++){
                allItemImages.push(additionalImages[i]);
            }
        }

        const itemDetails = {
            imageUrl: item.image.imageUrl,
            itemId: item.itemId,
            name: item.title,
            price: itemPrice,
            purchased: false,
            shippingPrice: shippingPrice,
            condition: item.condition,
            description: item.description,
            allImages: item.allImages
        };
        setSelectedItem(itemDetails);
        setShowModal(true);
      };
    
    const closeModal = () => {
        setSelectedItem(null);
        setShowModal(false);
    };

    return (
    <div className="item-list-container">
    {selectedItem && ReactDOM.createPortal(
      <ItemModal
        className="item-modal-in-list"
        item={selectedItem}
        showModal={showModal}
        setShowModal={setShowModal}
        closeModal={closeModal}
        toPurchase={false}
        post={post}
        setItemGives={setItemGives}
        setChangeItemIconColor={setChangeItemIconColor}
        socket={socket}
        onGive={onGive}
        setseenGifts={setseenGifts}
        onItemClick={onItemClick}
        CTAButton={"Select"}
        CTAFunction={"Select"}
      />,
      document.body // renders directly within <body>
    )}
        <div className="item-list">
            {uniqueItems.map((item, index) => (
            <span className="item" key={`${item.itemId}-${index}`} onClick={() => clickItem(item)}>
                {/* <p className="headline">{item.title}</p> */}
                <img className="product-img" src={item.image && item.image.imageUrl ? item.image.imageUrl : 'placeholder-image.jpg'} alt={item.title} />
                <p className='title'> {item.title}</p>
                <p className="price">
                    ${item.price && parseFloat(item.price.value).toFixed(2)}
                </p>
                <p className='line'></p>
                <p className='cta'>Send Now</p>
            </span>
            ))}
        </div>
    </div>
    );
}

ItemList.propTypes = {
items: PropTypes.array,
post: PropTypes.object,
setItemGives: PropTypes.func,
onGive: PropTypes.func,
setChangeItemIconColor: PropTypes.func,
socket: PropTypes.object,
onItemClick: PropTypes.func,
setseenGifts: PropTypes.func,
setIsLoading: PropTypes.func,
};